// extracted by mini-css-extract-plugin
module.exports = {"FAQ":"faq_FAQ__5nIB8","FAQAccordion":"faq_FAQAccordion__rbNv_"};